import { SettingsCustomFormFieldData } from '../../../models/settings/settings-custom-form-field-data.class';
import { FieldDataInterface } from '../../../models/settings/settings-custom-form-field-data.model';

export class SettingsSingleTagSelectorV1Field extends SettingsCustomFormFieldData {

    public categoryId: number | null = null;
    // constructor(type: string, position: number, id?: string, label?: string, mandatory?: boolean, active?: boolean) {
    //     super(type, position, id, label, mandatory, active);
    //     this.categoryId = null;
    // }

    public serialize(): FieldDataInterface {
        return this._serialize({category: this.categoryId});
    }

    public deserialize(field: FieldDataInterface): SettingsSingleTagSelectorV1Field {
        const self = new SettingsSingleTagSelectorV1Field(field.type, field.position, field.id, field.label, field.mandatory, field.active);
        // Deserialize other properties using class's logic
        self.categoryId = field.options.category;
        return self;
    }

    public update(updateData: Partial<SettingsSingleTagSelectorV1Field>) : SettingsSingleTagSelectorV1Field {
        // Create a new instance with the initial data
        const self = new SettingsSingleTagSelectorV1Field(
            this.type,
            this.position,
            this.id,
            this.label,
            this.mandatory,
            this.active,
        );

        self.categoryId = this.categoryId;

        // Apply any updates provided in updateData
        if (updateData) {
            Object.assign(self, updateData);
            // mark the field as changed    
            self.changed = true;
        }
        
        return self;
    }
}
